import { useState } from 'react'
import { ThemeProvider } from '@opallabs/hooks'
import { Button, Modal, WithTheme } from '@opallabs/lapidary'
import { GenerateContent } from './GenerateContent'

export type GenerateContentModalProps = WithTheme & {
  isVisible: boolean
  onCloseModal: (changes?: { prompt: string }) => void
}
export type promptProps = {
  useContext: boolean
  prompt: string
}

export const GenerateContentModal: React.FC<GenerateContentModalProps> = ({
  isVisible,
  onCloseModal,
  theme = 'dark',
}) => {
  const [prompt, setPrompt] = useState<promptProps>({
    useContext: true,
    prompt: '',
  })
  const [disabled, setDisabled] = useState<boolean>(false)
  const onClose = (closeArgs?: { prompt: string }) => {
    setPrompt({ useContext: true, prompt: '' })
    onCloseModal(closeArgs)
  }

  const onGenerateContent = () => {
    return onClose(prompt)
  }

  const onSetPrompt = ({ useContext, prompt }: promptProps) => {
    setPrompt({ useContext, prompt })
    setDisabled(!useContext && prompt.length == 0)
  }

  return (
    <ThemeProvider theme={theme}>
      <Modal.Root open={isVisible}>
        <Modal.Content onEscapeKeyDown={() => onClose()} style={{ width: 500 }}>
          <Modal.Title>
            <span aria-label="Robot" role="img" style={{ marginRight: 8 }}>
              🤖
            </span>
            Generate Content
          </Modal.Title>
          <Modal.Body>
            <Modal.Close onClick={() => onClose()} />
            <GenerateContent inModal={true} onSetPrompt={onSetPrompt} />
          </Modal.Body>
          <Modal.Footer>
            <Button
              buttonText="Cancel"
              className="cancel-add"
              name="Cancel generation"
              onClick={() => onClose()}
              variant="ghost"
            />
            <Button
              aria-disabled={disabled}
              buttonText="Generate Content"
              className="generate-content"
              disabled={disabled}
              name="Generate content"
              onClick={onGenerateContent}
              variant="primary"
            />
          </Modal.Footer>
        </Modal.Content>
      </Modal.Root>
    </ThemeProvider>
  )
}
